/**
 * Custom Product Options JavaScript - INFINITE LOOP FIXED VERSION
 * Handles radio group logic, file uploads, and cart integration
 * Compatible with Shopify Ella theme
 */

class CustomProductOptions {
  constructor() {
    this.selectedDesign = null;
    this.uploadedFile = null;
    this.customDescription = "";
    this.currentProduct = null;
    this.isUpdating = false; // Flag to prevent infinite loops

    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        this.setupEventListeners();
      });
    } else {
      this.setupEventListeners();
    }
  }

  showError(type, message) {
    const container = document.querySelector(`.${type}-option`);
    const errorDiv = container?.querySelector('.custom-design-option__error');
    if (errorDiv) {
      errorDiv.textContent = message;
      errorDiv.style.display = 'block';
      errorDiv.style.color = '#D32F2F'; // deep red
    }
  }

  clearAllErrors() {
    document.querySelectorAll('.custom-design-option__error').forEach(div => {
      div.textContent = '';
      div.style.display = 'none';
    });
  }


  setupEventListeners() {

    this.listenToVariantChanges();

    // Radio button change handlers
    const radioButtons = document.querySelectorAll(
      'input[name="designOption"]'
    );
    radioButtons.forEach((radio) => {
      radio.addEventListener("change", (e) => this.handleRadioChange(e));
    });

    // File upload handler
    const fileInput = document.getElementById("designFileInput");
    if (fileInput) {
      fileInput.addEventListener("change", (e) => this.handleFileUpload(e));
    }

    // Custom design description handler
    const descriptionTextarea = document.getElementById(
      "customDesignDescription"
    );
    if (descriptionTextarea) {
      descriptionTextarea.addEventListener("input", (e) =>
        this.handleDescriptionChange(e)
      );
    }

    // Form submission handler
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      productForm.addEventListener("submit", (e) => this.handleFormSubmit(e));
    }

    // Listen for design selection from popup (using existing popup system)
    this.setupPopupListeners();

    // Get current product data
    this.getCurrentProductData();

    const defaultRadio = document.querySelector(
      'input[name="designOption"]:first-of-type'
    );
    if (
      defaultRadio &&
      !document.querySelector('input[name="designOption"]:checked')
    ) {
      defaultRadio.checked = true;
      this.handleRadioChange({ target: defaultRadio });
    }
    this.observeSelectedDesignImageChange();
    setTimeout(() => {
  this.updateAddToCartButtonState();
}, 100);

  }

  listenToVariantChanges() {
    const variantDropdown = document.querySelector('form[action*="/cart/add"] select[name="id"]');
    const variantRadios = document.querySelectorAll('form[action*="/cart/add"] input[name="id"]');

    const recheck = () => this.updateAddToCartButtonState();

    if (variantDropdown) {
      variantDropdown.addEventListener("change", recheck);
    }

    if (variantRadios.length) {
      variantRadios.forEach((radio) => {
        radio.addEventListener("change", recheck);
      });
    }

    // Fallback for any theme script that sets variant via mutation
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      const observer = new MutationObserver(recheck);
      observer.observe(variantInput, { attributes: true, attributeFilter: ["value"] });
    }
  }

  handleRadioChange(event) {
    if (this.isUpdating) return;

    const selectedValue = event.target.value;

    const contentMap = {
      "ready-made": "readyMadeContent",
      upload: "uploadContent",
      custom: "customContent",
    };

    // Hide and reset unselected blocks
    Object.entries(contentMap).forEach(([key, blockId]) => {
      const block = document.getElementById(blockId);
      if (block) {
        block.style.display = key === selectedValue ? "block" : "none";
        if (key !== selectedValue) {
          this.resetInputs(blockId);
        }
      }
    });

    // Optionally call specific UI updates
    if (selectedValue === "ready-made") {
      this.clearSelectedDesign();
      this.clearUploadedFile();
      this.updateCustomPricing();
      this.updateUploadGuidance();
    } else if (selectedValue === "upload") {
      this.clearSelectedDesign();
      this.clearUploadedFile();
      this.updateCustomPricing();
      this.updateUploadGuidance();
    } else if (selectedValue === "custom") {
      this.clearSelectedDesign();
      this.clearUploadedFile();
      this.updateCustomPricing();
      this.updateUploadGuidance();
    }

    this.updateSelectedOption(selectedValue);
    this.triggerCartUpdate(selectedValue);
    this.updateAddToCartButtonState();
  }

  hideAllContentAreas() {
    const contentAreas = ["readyMadeContent", "uploadContent", "customContent"];

    contentAreas.forEach((id) => {
      const element = document.getElementById(id);
      if (element) {
        element.style.display = "none";
      }
    });
  }

  showReadyMadeContent() {
    const content = document.getElementById("readyMadeContent");
    if (content) {
      content.style.display = "block";
    }

    // Reset any previous selections
    this.clearSelectedDesign();
  }

  showUploadContent() {
    const content = document.getElementById("uploadContent");
    if (content) {
      content.style.display = "block";
    }

    // Update guidance text based on current product
    this.updateUploadGuidance();

    // Reset any previous uploads
    this.clearUploadedFile();
  }

  showCustomContent() {
    const content = document.getElementById("customContent");
    if (content) {
      content.style.display = "block";
    }

    // Update pricing based on current product
    this.updateCustomPricing();
  }

  setupPopupListeners() {
    // Listen for design selection from the existing popup system
    // The popup system updates hidden inputs directly, so we monitor those changes

    // Monitor changes to the hidden design inputs
    const designIdInput = document.getElementById("selectedDesignIdValue");

    if (designIdInput) {
      // Use a simple input event listener instead of MutationObserver to avoid loops
      designIdInput.addEventListener("input", () => {
        // Debounce to prevent rapid firing
        clearTimeout(this.designSelectionTimeout);
        this.designSelectionTimeout = setTimeout(() => {
          this.handleDesignSelectionFromPopup();
        }, 100);
      });

      // Also listen for value changes via property setter
      let lastValue = designIdInput.value;
      setInterval(() => {
        if (designIdInput.value !== lastValue) {
          lastValue = designIdInput.value;
          clearTimeout(this.designSelectionTimeout);
          this.designSelectionTimeout = setTimeout(() => {
            this.handleDesignSelectionFromPopup();
          }, 100);
        }
      }, 500);
    }
  }

  handleDesignSelectionFromPopup() {
    // Prevent infinite loops
    if (this.isUpdating) return;

    const designIdInput = document.getElementById("selectedDesignIdValue");
    const designImageInput = document.getElementById(
      "selectedDesignImageValue"
    );

    if (designIdInput && designIdInput.value) {
      // Get design data from the popup's hidden inputs
      const designData = {
        id: designIdInput.value,
        name: this.getDesignNameFromId(designIdInput.value),
        imageUrl: designImageInput ? designImageInput.value : "",
        category: "selected",
      };

      this.selectedDesign = designData;
      this.updateDesignPreview(designData);

      // Update cart attributes
      this.updateCartAttributesForDesign(designData);

    } else {
      this.clearSelectedDesign();
    }
    this.updateAddToCartButtonState();
  }

  getDesignNameFromId(designId) {
    // Try to get design name from the preview elements or design data
    const previewName = document.getElementById("selected-design-name");
    if (previewName && previewName.textContent) {
      return previewName.textContent;
    }

    // Fallback to design ID
    return `Design ${designId}`;
  }

  updateDesignPreview(designData) {
    const preview = document.getElementById("selectedDesignPreview");
    const image = document.getElementById("selectedDesignImage");
    const name = document.getElementById("selectedDesignName");

    if (preview && image && name && designData) {
      image.src = designData.imageUrl || "";
      image.alt = designData.name || "Selected Design";
      name.textContent = designData.name || "Selected Design";
      preview.style.display = "block";
    }
  }

  clearSelectedDesign() {
    // Prevent infinite loops
    if (this.isUpdating) return;

    this.isUpdating = true;

    const preview = document.getElementById("design-preview-container");
    if (preview) {
      preview.style.display = "none";
    }
    const previewImage = document.getElementById("preview-image");
    if(previewImage){
      previewImage.src = " ";
      previewImage.alt = "Design Preview";
    }
   
    // Clear hidden inputs
    const designIdInput = document.getElementById("selectedDesignIdValue");
    const designImageInput = document.getElementById(
      "selectedDesignImageValue"
    );

    if (designIdInput) designIdInput.value = "";
    if (designImageInput) designImageInput.value = "";

    this.selectedDesign = null;

    // Update cart attributes
    this.updateCartAttributesForDesign(null);

    this.isUpdating = false;
  }

  handleFileUpload(event) {
    const file = event.target.files[0];

    if (!file) {
      this.clearUploadedFile();
      return;
    }

    // Validate file
    const validation = this.validateFile(file);
    if (!validation.valid) {
      alert(validation.message);
      event.target.value = "";
      this.clearUploadedFile();
      return;
    }

    // Store file reference
    this.uploadedFile = file;

    // Update UI
    this.updateFileInfo(file);

    // Update hidden form field
    const fileNameField = document.getElementById("uploadedFileName");
    if (fileNameField) {
      fileNameField.value = file.name;
    }
  }

  validateFile(file) {
    const maxSize = 10 * 1024 * 1024; // 10MB
    const allowedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
      "application/postscript", // .ai files
      "image/vnd.adobe.photoshop", // .psd files
    ];

    const allowedExtensions = [".jpg", ".jpeg", ".png", ".pdf", ".ai", ".psd"];

    // Check file size
    if (file.size > maxSize) {
      return {
        valid: false,
        message:
          "File size must be less than 10MB. Please compress your file or choose a different format.",
      };
    }

    // Check file type
    const fileExtension = "." + file.name.split(".").pop().toLowerCase();
    if (
      !allowedTypes.includes(file.type) &&
      !allowedExtensions.includes(fileExtension)
    ) {
      return {
        valid: false,
        message:
          "Please upload a valid file format: JPG, PNG, PDF, AI, or PSD.",
      };
    }

    return { valid: true };
  }

  updateFileInfo(file) {
    const fileInfo = document.getElementById("fileInfo");
    const fileName = document.getElementById("fileName");
    const fileSize = document.getElementById("fileSize");

    if (fileInfo && fileName && fileSize) {
      fileName.textContent = `File: ${file.name}`;
      fileSize.textContent = `Size: ${this.formatFileSize(file.size)}`;
      fileInfo.style.display = "block";
    }
  }

  clearUploadedFile() {
    const fileInfo = document.getElementById("fileInfo");
    if (fileInfo) {
      fileInfo.style.display = "none";
    }

    const fileNameField = document.getElementById("uploadedFileName");
    if (fileNameField) {
      fileNameField.value = "";
    }

    this.uploadedFile = null;
  }

  formatFileSize(bytes) {
    if (bytes === 0) return "0 Bytes";

    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  }

  handleDescriptionChange(event) {
    this.customDescription = event.target.value;

    // Update hidden form field
    const descriptionField = document.getElementById(
      "customDesignDescriptionValue"
    );
    if (descriptionField) {
      descriptionField.value = this.customDescription;
    }
  }

  updateSelectedOption(option) {
    // Prevent infinite loops
    if (this.isUpdating) return;

    const selectedOptionField = document.getElementById("selectedDesignOption");
    if (selectedOptionField) {
      selectedOptionField.value = option;
    }
  }

  getCurrentProductData() {
    // Try to get product data from Shopify's global variables
    if (
      typeof window.ShopifyAnalytics !== "undefined" &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.product
    ) {
      this.currentProduct = window.ShopifyAnalytics.meta.product;
    }

    // Alternative: Get from meta tags
    if (!this.currentProduct) {
      const productIdMeta = document.querySelector('meta[name="product-id"]');
      if (productIdMeta) {
        this.currentProduct = { id: productIdMeta.content };
      }
    }

    // Alternative: Get from JSON script tag (common in Shopify themes)
    if (!this.currentProduct) {
      const productScript = document.querySelector(
        'script[type="application/json"][data-product-json]'
      );
      if (productScript) {
        try {
          this.currentProduct = JSON.parse(productScript.textContent);
        } catch (e) {
          console.warn("Could not parse product JSON:", e);
        }
      }
    }
  }

  updateUploadGuidance() {
    // Update guidance text based on product type
    if (!this.currentProduct) return;

    const sizeLimit = document.getElementById("sizeLimit");
    const dimensionGuidance = document.getElementById("dimensionGuidance");

    // Example: Different guidance for different product types
    const productType =
      this.currentProduct.type || this.currentProduct.product_type || "";

    switch (productType.toLowerCase()) {
      case "t-shirt":
      case "tshirt":
      case "shirt":
        if (dimensionGuidance) {
          dimensionGuidance.textContent =
            'Recommended: 12"x12" at 300 DPI for best print quality';
        }
        break;
      case "mug":
      case "cup":
        if (dimensionGuidance) {
          dimensionGuidance.textContent =
            'Recommended: 9.5"x8.2" at 300 DPI, wrap-around design';
        }
        break;
      case "poster":
      case "print":
        if (dimensionGuidance) {
          dimensionGuidance.textContent =
            "Recommended: Match poster dimensions at 300 DPI";
        }
        break;
      default:
        if (dimensionGuidance) {
          dimensionGuidance.textContent =
            "Recommended: 300 DPI, print-ready quality";
        }
    }
  }

  updateCustomPricing() {
    // Update custom design pricing to 15 AED
    const priceElement = document.getElementById("customPriceAmount");
    const variationLimit = document.getElementById("variationLimit");

    // Set fixed price to 15 AED
    const customPrice = "15 AED";
    const variations = "Up to 3 design variations";

    if (priceElement) {
      priceElement.textContent = customPrice;
    }

    if (variationLimit) {
      variationLimit.textContent = variations;
    }
  }

  triggerCartUpdate(selectedOption) {
    // Prevent infinite loops
    if (this.isUpdating) return;

    // Trigger cart integration update
    if (window.shopifyCartIntegration) {
      window.shopifyCartIntegration.handleDesignOptionChange({
        option: selectedOption,
        designId: this.selectedDesign ? this.selectedDesign.id : "",
        designName: this.selectedDesign ? this.selectedDesign.name : "",
        designImage: this.selectedDesign ? this.selectedDesign.imageUrl : "",
        description: this.customDescription,
        fileName: this.uploadedFile ? this.uploadedFile.name : "",
      });
    }
  }

  updateCartAttributesForDesign(designData) {
    // Prevent infinite loops
    if (this.isUpdating) return;

    // Update cart attributes when design is selected/cleared
    const designOptionField = document.getElementById("selectedDesignOption");
    if (designOptionField && designOptionField.value === "ready-made") {
      this.triggerCartUpdate("ready-made");
    }
  }

  handleFormSubmit(event) {
    const selectedOption = document.querySelector(
      'input[name="designOption"]:checked'
    );

    if (!selectedOption) {
      event.preventDefault();
      alert("Please select a design option before adding to cart.");
      return false;
    }

    // Validate based on selected option
    switch (selectedOption.value) {
      case "ready-made":
        const designIdInput = document.getElementById("selectedDesignIdValue");
        if (!designIdInput || !designIdInput.value) {
          event.preventDefault();
          alert("Please select a design from our collection.");
          return false;
        }
        break;

      case "upload":
        if (!this.uploadedFile) {
          event.preventDefault();
          alert("Please upload your design file.");
          return false;
        }
        break;

      case "custom":
        if (!this.customDescription.trim()) {
          event.preventDefault();
          alert("Please describe your custom design requirements.");
          return false;
        }
        break;
    }

    // Final cart attributes update before submission
    this.triggerCartUpdate(selectedOption.value);

    return true;
  }
  resetInputs(containerId) {
    const container = document.getElementById(containerId);
    if (!container) return;

    const inputs = container.querySelectorAll("input, textarea, select");
    inputs.forEach((input) => {
      if (input.type === "radio" || input.type === "checkbox") {
        input.checked = false;
      } else if (input.type === "file") {
        input.value = null;
      } else {
        input.value = "";
      }
    });
  }

  updateAddToCartButtonState() {
    const addToCartBtn = document.querySelector('form[action*="/cart/add"] button[type="submit"]');
    const selectedOption = document.querySelector('input[name="designOption"]:checked');
    const designImageValue = document.getElementById("selectedDesignImageValue");
    const designIdValue = document.getElementById("selectedDesignIdValue");
    const fileInput = document.getElementById('designFileInput');
    const quantityInput = document.querySelector('input[name="quantity"]');
    const plusButton = document.querySelector('button[name="plus"]');
    const minusButton = document.querySelector('button[name="minus"]');
  
    if (!addToCartBtn) {
      console.warn("Add to Cart button not found");
      return;
    }
    if (
      selectedOption &&
      selectedOption.value === "ready-made" &&
      (
        !designImageValue || !designImageValue.value.trim() ||
        !designIdValue || !designIdValue.value.trim()
      )
    ) {
      addToCartBtn.disabled = true;
      this.clearAllErrors();
      this.showError("ready-made","Please select a design.");
    } else if (selectedOption && selectedOption.value === "upload") {
      if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
        addToCartBtn.disabled = true;
        this.clearAllErrors();
        this.showError("upload","Please upload a design file.");
      } else {
        addToCartBtn.disabled = false;
        this.clearAllErrors();
      }
      // Listen for file selection
      fileInput.addEventListener("change", () => {
        if (fileInput.files && fileInput.files.length > 0) {
          addToCartBtn.disabled = false;
          this.clearAllErrors();
        } else {
          addToCartBtn.disabled = true;
          this.clearAllErrors();
          this.showError("upload","Please upload a design file.");
        }
      });
      
    } else {
      addToCartBtn.disabled = false;
      this.clearAllErrors();
    }
    if (quantityInput) quantityInput.disabled = false;
    if (plusButton) plusButton.disabled = false;
    if (minusButton) minusButton.disabled = false;

  }

  observeSelectedDesignImageChange() {
    const designImageInput = document.getElementById("selectedDesignImageValue");
    const designIdInput = document.getElementById("selectedDesignIdValue");
    if (!designImageInput && !designIdInput) return;
  
    const updateButtonStateDebounced = this.debounce(() => {
      this.updateAddToCartButtonState();
    }, 100);
  
    if (designImageInput) {
      designImageInput.addEventListener("input", updateButtonStateDebounced);
  
      const observer1 = new MutationObserver(updateButtonStateDebounced);
      observer1.observe(designImageInput, {
        attributes: true,
        attributeFilter: ["value"],
      });
    }
  
    if (designIdInput) {
      designIdInput.addEventListener("input", updateButtonStateDebounced);
  
      const observer2 = new MutationObserver(updateButtonStateDebounced);
      observer2.observe(designIdInput, {
        attributes: true,
        attributeFilter: ["value"],
      });
    }
  }
  
  // Add this debounce helper method to your class:
  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }


  handleDesignChange(event) {
    const selectedOption = event.target.value;
    const addToCartButton = document.querySelector('[type="submit"]');
    const selectedImageInput = document.getElementById('selectedDesignImageValue');
    const fileInput = document.getElementById('designFileInput');

  
    if (selectedOption === "ready-made") {
      const hasImage = selectedImageInput && selectedImageInput.value.trim() !== '';
      addToCartButton.disabled = !hasImage;
      if(!hasImage){
        this.clearAllErrors();
        this.showError("ready-made","Please select a design.");
      } else {
        this.clearAllErrors();
      }
    } else if (selectedOption === "upload") {
      if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
        addToCartButton.disabled = true;
        this.clearAllErrors();
        this.showError("upload","Please upload a design file.");
      } else {
        addToCartButton.disabled = false;
        this.clearAllErrors();
      }
      // Listen for file selection
      fileInput.addEventListener("change", () => {
        if (fileInput.files && fileInput.files.length > 0) {
          addToCartButton.disabled = false;
          this.clearAllErrors();
        } else {
          addToCartButton.disabled = true;
          this.clearAllErrors();
          this.showError("upload","Please upload a design file.");
        }
      });
      
    } else {
      addToCartButton.disabled = false;
      this.clearAllErrors();
    }
  }
}
// Initialize when DOM is ready
const customProductOptions = new CustomProductOptions();

// Export for global access if needed
window.CustomProductOptions = CustomProductOptions;
window.customProductOptions = customProductOptions;
